import axios from "axios";
import apiconfig from "../config/config";

const avdurl1 = apiconfig.production.apiBaseUrl;
const api = axios.create({
  baseURL: avdurl1,
});

const setApiBaseUrl = (url) => {
  api.defaults.baseURL = url;
};


const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }
};

const allUsersProfile = (page, limit) => {
  return api.get(`admin/all-users-organisers?page=${page}&limit=${limit}`)
};

const getUserByID = (id, adminUserId) => {
  return api.get(`logIn/user-by-profile_id?profile_id=${id}`, {
    headers: {
      "user_id": adminUserId
    }
  });
};

const login = (body) => {
  return api.post("admin-reg/admin-login", body);
};

const logout = (body) => {
  return api.post("admin-reg/logout", body);
};
const getAllEvents = (page, limit) => {
  // return api.get("/event/all-events");
  return api.get(`admin/all-events?page=${page}&limit=${limit}`)
};

const getEventById = (id, adminUserId) => {
  return api.get(`event/get-event-by-id?ID_event=${id}`, {
    headers: {
      "user_id": adminUserId
    }
  });
};

const generateNewToken = (body) => {
  return api.post("admin-reg/refresh-token-admin", body);
};
const updteUserDetails = (id, body) => {
  return api.put(`signup/update-user/${id}`, body);
};

const updateEvent = (body, eventId, adminUserId) => {
  return api.put(`event/edit-event?eventId=${eventId}`, body, {
    headers: {
      "user_id": adminUserId
    }
  });
};

const moveWaitlist = (eventId, body, adminUserId) => {
  return api.put(`event/manage-waiting?event_id=${eventId}`, body, {
    headers: {
      "user_id": adminUserId
    }
  });
};

const updateCoHostStatus = (event_id, participant_id, body, adminUserId) => {
  return api.put(
    `event/accept-request-co-host?event_id=${event_id}&participant_id=${participant_id}`,
    body, {
    headers: {
      "user_id": adminUserId
    }
  }
  );
};

const eventReviewStatus = (event_id, body) => {
  return api.put(`admin/approval-status-change?_id=${event_id}`, body);
};

const getFormByUserId = (id) => {
  return api.get(`admin/submitted-form-by-user_id?user_id=${id}`);
};

const adminApproveForm = (user_id, body) => {
  return api.put(`admin/org-confirmation?_id=${user_id}`, body);
};

const adminAddUserSlot = (body, id) => {
  return api.post(`admin/admin-book-slot?event_id=${id}`, body);
};

const cancelReservation = (eventId, body, adminUserId) => {
  return api.put(`event/participant-slot-status?eventId=${eventId}`, body, {
    headers: {
      "user_id": adminUserId
    }
  })
};

const cancelledSlotRefundAmount = (body) => {
  return api.post(`payment/create-refund`, body);
};

const waitListRefundAmount = (body) => {
  return api.post(`payment/create-refund-waitlist`, body);
};

const refundRequestAfterTripEnd = (body) => {
  return api.post(`payment/create-refund-requested`, body);
};


const updateKYCVerification = (userId, body) => {
  return api.put(`admin/update-kyc-status?user_id=${userId}`, body);
};

const sendFormRequest = (id) => {
  return api.put(`admin/send-form?_id=${id}`);
};
const multiImageUpload = (body) => {
  return api.post("image/multi-upload", body, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const homeImages = (body) => {
  return api.post(`home/home-images`, body);
};

const updateHomeImages = (body, id) => {
  return api.put(`home/update-home-images?_id=${id}`, body);
};

const getHomeImages = () => {
  return api.get(`home/images-home`);
};

const deleteImage = (imageUrl) => {
  return api.delete(`image/delete?imageUrl=${imageUrl}`);
};

const postHomepageReviews = (body) => {
  return api.post(`home/home-reviews`, body);
};

const getHomepageReviews = () => {
  return api.get(`home/reviews-home`);
};

const updateHomeReviews = (body) => {
  return api.put(`home/update-home-reviews`, body);
};

const getMBTFeedback = () => {
  return api.get(`feedback/all-mbt-feedback`);
}

const getOrganiserFeedback = () => {
  return api.get(`feedback/all-organizers-feedback`);
}

const getAllEventsFeedback = () => {
  return api.get(`feedback/all-events-feedback`);
}

const getAllOrganisersRatings = () => {
  return api.get(`feedback/all-organizers-feedback`);
}


const getEventFeedbackByID = (id) => {
  return api.get(`feedback/feedbacks-by-event?eventId=${id}`);
}

const getAllReports = (adminUserId) => {
  return api.get(`issue/reports`, {
    headers: {
      "user_id": adminUserId
    }
  });
}

const getReportById = (id) => {
  return api.get(`issue/reports-by-userid?userId=${id}`);
}

const getTotalUsersEngaged = (id) => {
  return api.get(`analysis/total-engaged-users`);
};

const getEventParticipationRating = (id) => {
  return api.get(`analysis/event-participation-rate`);
};

const getTotalOrganisersEngaged = (id) => {
  return api.get(`analysis/total-organizers-engaged`);
};

const getTotalEventsSummary = (id) => {
  return api.get(`analysis/events-summary`);
};

const getAllRevenueData = () => {
  return api.get(`analysis/combined-analytics`);
}

const refundRejected = (eventId, participantId) => {
  return api.put(`/event/update-participant-refund-status?eventId=${eventId}&participantId=${participantId}`);
};

const updateRefundStatus = (participantId) => {
  return api.put(`/payment/update-refund-status?participant_id=${participantId}`);
};

const updateOrgansierManagementRequestViewed = (userId) => {
  return api.put(`/admin/update-org-request-viewed?user_id=${userId}`)
}

const updateBookingManagementRequestViewed = (eventId, participantId) => {
  return api.put(`/admin/update-refund-request-viewed?event_id=${eventId}&participant_id=${participantId}`)
}

const getUserSeachQuery = (searchQuery) => {
  return api.get(`/admin/search/users?query=${searchQuery}`)
}

const getEventsSeachQuery = (searchQuery) => {
  return api.get(`/admin/search/events?query=${searchQuery}`)
}

const getEventsCounts = () => {
  return api.get(`/admin/events/counts`)
}

const orgRequestUnviewed = () => {
  return api.get(`/admin/count-unviewed-org-requests`)
}

const usersFormVerified = () => {
  return api.get(`/admin/users/form-verified`)
}
const refundRequestViewedCount = () => {
  return api.get(`/admin/events/participants-refund-request-viewed`)
}
const reasonForUnattended = () => {
  return api.get(`/admin/events/participants-reason-unattended`)
}
const APIServices = {
  setApiBaseUrl,
  setAuthToken,
  allUsersProfile,
  getUserByID,
  login,
  generateNewToken,
  getAllEvents,
  getEventById,
  updteUserDetails,
  updateEvent,
  moveWaitlist,
  updateCoHostStatus,
  eventReviewStatus,
  getFormByUserId,
  adminApproveForm,
  adminAddUserSlot,
  cancelReservation,
  cancelledSlotRefundAmount,
  updateKYCVerification,
  sendFormRequest,
  multiImageUpload,
  homeImages,
  updateHomeImages,
  getHomeImages,
  deleteImage,
  postHomepageReviews,
  getHomepageReviews,
  updateHomeReviews,
  getMBTFeedback,
  getOrganiserFeedback,
  getAllEventsFeedback,
  getAllOrganisersRatings,
  getEventFeedbackByID,
  getAllReports,
  getReportById,
  getTotalUsersEngaged,
  getEventParticipationRating,
  getTotalOrganisersEngaged,
  getTotalEventsSummary,
  getAllRevenueData,
  logout,
  refundRejected,
  updateRefundStatus,
  waitListRefundAmount,
  refundRequestAfterTripEnd,
  updateOrgansierManagementRequestViewed,
  updateBookingManagementRequestViewed,
  getUserSeachQuery,
  getEventsSeachQuery,
  getEventsCounts,
  orgRequestUnviewed,
  usersFormVerified,
  refundRequestViewedCount,
  reasonForUnattended,
};

export default APIServices;
